/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityPageThreadedFeedInternal} from '../api'

export const useMutationActivityPageThreadedFeedInternal = createReactQueryMutationHook('activityPageThreadedFeedInternal', activityPageThreadedFeedInternal)
